import { useCallback, useEffect, useState, useMemo } from "react";
import toast from "react-hot-toast";
import {
  addExpenseApi,
  updateExpenseApi,
  getExpenseByIdApi,
} from "../../Api/Expense";
import { getTypeApi } from "../../Api/taxonomy";
import { getAllBankApi } from "../../Api/Bank";
import { getUserByRoleType } from "../../Api/user";
import { getDonationTPApi } from "../../Api/DonationTypePurpose";
import { fetchPurposeApi } from "../../Api/PurposeType";
import { fetchDonationTypeApi } from "../../Api/DonationTypes";
import { getBsByIdApi } from "../../Api/BankStatement";

type ExpenseType = {
  id: string;
  Id: string;
  value: string;
  parentId: string | null;
  type: string;
  code: number;
  Purpose: string;
  Mode: string;
  From: string;
};
type BanksData = {
  id: string;
  Id: string;
  value: string;
  Mode: string;
  From: string;
  Name: string;
  label: string;
  donationPurposeId: string;
  donationPurpose?: { id: string; name: string } | null;
};
type AdminsData = {
  label: string;
  id: string;
  value: string;
};
interface Option {
  id: number;
  value: string;
  label: string;
}
interface Options {
  id: string;
  parentId: string | null;
  name: string;
  isHiddenForUser: boolean;
}
interface DonationTypePurposeInterface {
  id: string;
  donationTypeId: string;
  donationPurposeId: string;
  purposeid: string;
  label: string;
}
const ExpenseModes: Option[] = [
  {
    id: 1,
    value: "Bank",
    label: "Bank",
  },
  {
    id: 2,
    value: "Cash",
    label: "Cash",
  },
];
interface ExpenseFormProps {
  url: string;
  setformmodal?: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string | null;
  onSuccess?: () => void;
  bankStatementId?: string;
  onClose: () => void;
}

export const ExpenseForm = ({
  url,
  setformmodal,
  id,
  onSuccess,
  bankStatementId,
  onClose,
}: ExpenseFormProps) => {
  const [data, setData] = useState<ExpenseType[]>([]);
  const [DataPurpose, setDataPurpose] = useState<ExpenseType[]>([]);
  const [BankData, setBankData] = useState<BanksData[]>([]);
  const [AdminData, setAdminData] = useState<AdminsData[]>([]);
  const [selectedExpenseType, setSelectedExpenseType] = useState<string | null>(
    null
  );
  const [selectedExpenseSubType, setSelectedExpenseSubType] = useState<
    string | null
  >(null);
  const [expenseAmount, setExpenseAmount] = useState<string | number>("");
  const [description, setDescription] = useState<string>("");
  const [expenseOn, setExpenseOn] = useState<string>("");
  const [isEdit, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [selectedexpenseMode, setExpenseMode] = useState<Option | null>(null);
  const [from, setFrom] = useState<string | null>(null);
  const [donationTypeData, setDonationTypeData] = useState([]);
  const [donationTypeOptions, setDonationTypeOptions] = useState<Options[]>([]);
  const [purposeOptions, setPurposeOptions] = useState<Options[]>([]);
  const [donationPurpose, setDonationPurpose] = useState<Option | null>(
    null
  ) as any;
  const [donationType, setDonationType] = useState<Option | null>(null) as any;
  const [donationTP, setDonationTP] = useState<DonationTypePurposeInterface[]>(
    []
  );

  useEffect(() => {
    const fetchAllTaxonomies = async () => {
      try {
        const [typeResponse, purposeResponse, fetchDonation] =
          await Promise.all([
            fetchDonationTypeApi(url),
            fetchPurposeApi(url),
            getDonationTPApi("donationTPId", url),
          ]);
        setDonationTypeOptions(typeResponse);
        setPurposeOptions(purposeResponse as Options[]);
        setDonationTP(fetchDonation);
      } catch (error) {
        toast.error("Failed to load donation types and purposes", {
          id: "donationTypeError",
        });
      }
    };

    fetchAllTaxonomies();
  }, [url]);

  const donationOptions = useMemo(
    () =>
      donationTypeOptions
        .filter((resp) =>
          donationTP.some((tp) => tp.donationTypeId === resp.id)
        )
        .map((DonationType) => ({
          value: DonationType.name,
          id: DonationType.id,
          label: DonationType.name,
        })),
    [donationTypeOptions, donationTP]
  );

  const donationPurposeOptions = useMemo(
    () =>
      purposeOptions.map((DonationPurpose) => ({
        value: DonationPurpose.name,
        id: DonationPurpose.id,
        label: DonationPurpose.name,
      })),
    [purposeOptions]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getTypeApi("Expense Category", url);
        setData(response);
        const res = await getTypeApi("Purpose", url);
        setDataPurpose(res);
        const res2 = await getTypeApi("Donation Type", url);
        setDonationTypeData(res2);
      } catch (error) { }
    };
    fetchData();
  }, [url]);

  const fetchBanks = async () => {
    try {

      const response = await getAllBankApi(url);
      const formattedBanks = response.map((bank: any) => ({
        id: bank.id,
        label: `${bank.name} - ${bank.accountNumber}`,
        donationPurposeId: bank.donationPurposeId,
        donationPurpose: bank.donationPurpose,
      }));
      setBankData(formattedBanks);
    } catch (error) {
      toast.error("Error fetching bank data.", { id: "bankError" });
      setLoading(false);
      setHasError(true);
    }
  };
  const fetchAdminData = async () => {
    try {
      const response = await getUserByRoleType(2, url);
      const formattedAdminData = response.map((admin: any) => ({
        id: admin.id,
        label: admin.name,
      }));
      setAdminData(formattedAdminData);
    } catch (error) {
      toast.error("Error fetching Admin data", { id: "adminError" });

      toast.error("Network Error.", { id: "networkError" });
      setLoading(false);
      setHasError(true);
    }
  };
  useEffect(() => {
    fetchAdminData();
    fetchBanks();
  }, [url]);

  const fetchExpense = async () => {
    if (id) {
      try {
        const expenseData = await getExpenseByIdApi(url, id);
        if (expenseData) {
          
          const expenseMode = ExpenseModes.find(
            (mode) => mode.value === expenseData.mode
          );
          const donationTypeMode = expenseData.donationType
            ? {
              value: expenseData.donationType,
              id: expenseData.donationTypeId,
              label: expenseData.donationType,
            }
            : null;
          const donationPurposeMode = expenseData.donationPurpose
            ? {
              value: expenseData.donationPurpose,
              id: expenseData.donationPurposeId,
              label: expenseData.donationPurpose,
            }
            : null;
          setExpenseMode(expenseMode || null);
          setFrom(expenseData.from || "");
          setSelectedExpenseType(expenseData.typeId || "");
          setSelectedExpenseSubType(expenseData.subTypeId || "");
          setExpenseAmount(expenseData.amount || 0);
          setDescription(expenseData.desc || "");
          setDonationType(donationTypeMode);
          setDonationPurpose(donationPurposeMode);
          setExpenseOn(
            expenseData.expenseOn ? expenseData.expenseOn.split("T")[0] : ""
          );
          setLoading(false);
          setIsEditMode(true);
        }
      } catch (error) {
        toast.error("Error fetching expense data.");
        setLoading(false);
        setHasError(true);
      }
    }
  };

  useEffect(() => {
    fetchExpense();
  }, [id, url, donationOptions, donationPurposeOptions]);

  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      setLoading(true);
    } else {
      setIsEditMode(false);
      setLoading(false);
    }
  }, [id]);

  const expenseTypes = data.filter(
    (item) => item.type === "Expense Category" && item.parentId === null
  );

  const filteredSubType = data
    .filter((item) => item.parentId === selectedExpenseType)
    .map((subType) => ({ value: subType.id, label: subType.value }));

  const handleSubmitClick = async (event, actionType) => {
    event.preventDefault();
    if (
      !selectedexpenseMode ||
      !from ||
      !selectedExpenseSubType ||
      !donationPurpose ||
      !expenseAmount ||
      isNaN(Number(expenseAmount)) ||
      Number(expenseAmount) <= 0
    ) {
      toast.error("Please fill all the fields");
      return;
    }
    try {
      const donationTypeId = donationType ? donationType.id : null;
      if (isEdit) {
        await updateExpenseApi(
          id,
          selectedexpenseMode.value,
          from,
          donationPurpose.id,
          donationTypeId,
          Number(expenseAmount),
          selectedExpenseSubType,
          expenseOn,
          description,
          url
        );
        if (onSuccess) onSuccess();
        onClose();
        toast.success("Expense Updated Successfully");
      } else {
        await addExpenseApi(
          selectedexpenseMode.value,
          from,
          selectedExpenseSubType,
          donationPurpose.id,
          donationTypeId,
          Number(expenseAmount),
          expenseOn,
          description,
          url,
          bankStatementId
        );
        if (onSuccess) onSuccess();
        toast.success("Expense Added Successfully");
      }
      if (actionType === "saveAndClose") {
        handleResetForm();
      } else {
        setExpenseAmount(0);
        setDescription("");
      }
    } catch (error) {
      toast.error("Failed to process expense");
    }
  };

  const handleResetForm = () => {
    setExpenseMode(null);
    setFrom("");
    setSelectedExpenseType(null);
    setSelectedExpenseSubType("");
    setDonationPurpose(null);
    setDonationType(null);
    setExpenseAmount(0);
    setDescription("");
    setExpenseOn("");
    onClose();
  };

  const fetchBankStatementData = async () => {
    if (bankStatementId) {
      try {
        const response = await getBsByIdApi(url, bankStatementId);
        const bankMode = ExpenseModes.find((mode) => mode.value === "Bank");
        setExpenseMode(bankMode || null);
        setExpenseAmount(response.transactionAmount || 0);
        setExpenseOn(response.valueDate ? response.valueDate.split("T")[0] : "");
        const matchingBank = BankData.find(
          (bank) => bank.id === response.bankId
        );
        if (matchingBank) {
          setFrom(matchingBank.id);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    if (bankStatementId && BankData.length > 0) {
      fetchBankStatementData();
    }
  }, [bankStatementId, BankData]);

  useEffect(() => {
    if (
      selectedexpenseMode?.value === "Bank" &&
      from &&
      BankData.length > 0 &&
      donationPurposeOptions.length > 0
    ) {
      const selectedBank = BankData.find((bank) => bank.id === from);
      if (selectedBank?.donationPurposeId) {
        const matchedPurpose = donationPurposeOptions.find(
          (purpose) => purpose.id === selectedBank.donationPurposeId
        );

        if (matchedPurpose) {
          setDonationPurpose({
            value: matchedPurpose.value,
            id: matchedPurpose.id,
            label: matchedPurpose.label,
          });
          setDonationType(null);
        }
      }
    }
  }, [selectedexpenseMode?.value, from, BankData, donationPurposeOptions]);

  const filteredDonationTypes = useMemo(() => {
    return donationPurpose
      ? (donationTP
        .filter((dtp) => dtp.donationPurposeId === donationPurpose.id)
        .map((dtp) =>
          donationOptions.find(
            (option) => option.id.toString() === dtp.donationTypeId
          )
        )
        .filter((type) => type !== undefined) as any[])
      : (donationOptions as any[]);
  }, [donationPurpose, donationOptions, donationTP]);

  useEffect(() => {
    if (!donationType && filteredDonationTypes.length === 1) {
      setDonationType(filteredDonationTypes[0]);
    }
  }, [donationType, filteredDonationTypes]);



  return (
    <div className="px-4">
      <div>
        {loading ? (
          <div className="flex justify-center items-center h-screen">
            <div
              className="flex justify-center items-center h-12 w-12 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] text-blue-600"
              role="status"
            >
              <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                Loading...
              </span>
            </div>
          </div>
        ) : hasError ? (
          <div className="flex justify-center items-center h-screen">
            {/* Blank page when there’s an error */}
          </div>
        ) : (
          <div>
            <h2 className="text-3xl font-bold text-blue-600 mb-5 mt-5">
              {isEdit ? "Update Expense Details" : "Add New Expense Details"}
            </h2>
            <form className="mt-8 space-y-4">
              <div className="flex flex-col space-y-3 ">
                <label className="font-medium text-black dark:text-gray-200 ">
                  Mode
                </label>
                <select
                  className="p-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500"
                  value={selectedexpenseMode?.value || ""}
                  required
                  onChange={(e) => {
                    const mode = ExpenseModes.find(
                      (option) => option.value === e.target.value
                    );
                    setExpenseMode(mode || null);
                    setFrom(null);
                  }}
                >
                  <option value="">Select  Mode</option>
                  {ExpenseModes.map((mode) => (
                    <option key={mode.id} value={mode.value}>
                      {mode.label}
                    </option>
                  ))}
                </select>

                {selectedexpenseMode && (
                  <div>
                    <label className="block mb-2 font-medium text-black dark:text-gray-200">
                      From
                    </label>

                    <select
                      className="w-full p-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500"
                      value={from || ""}
                      required
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        setFrom(selectedValue);

                        if (selectedexpenseMode?.value === "Bank") {
                          const selectedBank = BankData.find(
                            (bank) => bank.id === selectedValue
                          );
                          if (selectedBank?.donationPurpose) {
                            setDonationPurpose({
                              value: selectedBank.donationPurpose.name,
                              id: selectedBank.donationPurpose.id,
                              label: selectedBank.donationPurpose.name,
                            });
                            setDonationType(null);
                          }
                        }
                      }}
                    >
                      <option value="" disabled>
                        {selectedexpenseMode?.value === "Bank"
                          ? "Choose Bank - Account Number"
                          : "Select Person"}
                      </option>
                      {(selectedexpenseMode?.value === "Bank"
                        ? BankData
                        : AdminData
                      ).map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <label className="font-medium text-black dark:text-gray-200">
                  Type
                </label>
                <select
                  className="p-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500"
                  value={selectedExpenseType || ""}
                  required
                  onChange={(e) => {
                    setSelectedExpenseType(e.target.value);
                    setSelectedExpenseSubType(null);
                  }}
                >
                  <option value="">Select Expense Type</option>
                  {expenseTypes.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.value}
                    </option>
                  ))}
                </select>

                <label className="font-medium text-black dark:text-gray-200">
                  Sub Type
                </label>
                <select
                  className="p-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500"
                  value={selectedExpenseSubType || ""}
                  required
                  onChange={(e) => setSelectedExpenseSubType(e.target.value)}
                >
                  <option value="">Select Sub Type</option>
                  {filteredSubType.map((subType) => (
                    <option key={subType.value} value={subType.value}>
                      {subType.label}
                    </option>
                  ))}
                </select>

                <div>
                  <label className="font-medium text-black">
                    Donation Purpose
                  </label>
                  <select
                    id="donation-purpose"
                    required
                    value={donationPurpose?.value || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      const selectedPurpose = donationPurposeOptions.find(
                        (purpose) => purpose.value === value
                      );

                      if (selectedPurpose) {
                        setDonationPurpose({
                          value: selectedPurpose.value,
                          id: selectedPurpose.id,
                          label: selectedPurpose.value,
                        });

                        setDonationType(null);
                      }
                    }}
                    className="w-full mt-2 p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-500"
                  >
                    <option value="" disabled>
                      Select Donation Purpose
                    </option>
                    {donationPurposeOptions.map((option) => (
                      <option key={option.id} value={option.value}>
                        {option.value}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="font-medium text-black">
                    Donation Type
                  </label>
                  <select
                    id="donationType"
                    value={
                      donationType?.value ||
                      (filteredDonationTypes.length === 1
                        ? filteredDonationTypes[0].value
                        : "")
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!value) {
                        setDonationType(null);
                        return;
                      }
                      const selectedType = donationOptions.find(
                        (option) => option.value === value
                      );

                      if (selectedType) {
                        setDonationType(selectedType);
                      }
                    }}
                    className="w-full mt-2 p-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-500"
                  >
                    <option value="" disabled>
                      Select Donation Type
                    </option>
                    {filteredDonationTypes.map((option) => (
                      <option key={option.id} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <label className="font-medium text-black dark:text-gray-200">
                  Amount
                </label>
                <input
                  type="number"
                  className="p-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500"
                  value={expenseAmount}
                  required
                  onChange={(e) => setExpenseAmount(e.target.value)}
                />

                <label className=" font-medium text-black dark:text-gray-200">
                  Expense On
                </label>
                <input
                  type="date"
                  className="p-2 border border-gray-300 rounded leg text-gray-700 focus: outline-none focus focus:ring-blue-400 focus:border-blue-500"
                  value={expenseOn}
                  required
                  onChange={(e) => setExpenseOn(e.target.value)}
                />

                <label className="font-medium  text-black dark:text-gray-200">
                  Description
                </label>
                <textarea
                  className="p-2 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>

              <div className="flex justify-start space-x-4 mt-6">
                {!isEdit && (
                  <button
                    type="button"
                    onClick={(e) => handleSubmitClick(e, "saveAndNew")}
                    className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-6 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
                  >
                    Save and New
                  </button>
                )}
                <button
                  type="button"
                  onClick={(e) => handleSubmitClick(e, "saveAndClose")}
                  className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-6 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
                >
                  {isEdit ? "Update" : "Save and Close"}
                </button>
                <button
                  type="button"
                  className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-6 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
                  onClick={handleResetForm}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};
